import React from 'react';
import { useDispatch } from 'react-redux';
import i18n from 'i18n';
import { StubLoginToProceed } from 'components/StubLoginToProceed';
import WatchListIcon from 'components/Icons/menu-volia/watchlist';
import { navigateToAuthPage } from 'actions/app';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const NotLoggedStub = () => {
  const dispatch = useDispatch();
  const onLoginEnter = () => {
    innerAnalyticsVolia.postEvent({
      eventGroup: 'dashboard: MY_WATCHLIST',
      eventName: 'click sign in',
    });

    dispatch(navigateToAuthPage());
  };

  return (
    <StubLoginToProceed onLoginEnter={onLoginEnter}>
      <WatchListIcon width={192} height={192} />
      <div>{i18n.t('watchlist.loginToProceed')}</div>
    </StubLoginToProceed>
  );
};

export default NotLoggedStub;
